// pages/UsersEdit.js

import Header from "../components/HomeScreen/Header";
import UsersEdit from "../components/MenuScreen/ProfileEdit";
import Footer from "../components/HomeScreen/Footer";

const Edit = () => {
  return (
    <>
      <Header />
      <UsersEdit />
      <Footer />
    </>
  );
}
export default Edit;
